<template>
  <div>
    <v-dialog v-model="props.visible">
      <v-card class="mx-auto">
        <div class="bg-primary py-3 px-4">
          <span>
            <v-card-title>{{ title }}</v-card-title>
          </span>
        </div>
        <v-card-text class="px-4">
          {{ props.text }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center mb-3">
          <v-btn color="secondary" variant="outlined" @click="handleCancel">{{ cancelTitle }}</v-btn>
          <v-btn :color="continueButtonColor" @click="handleContinue">{{ continueTitle }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent } from 'vue'
export default defineComponent({
  name: 'ConfirmationDialog',
  props: {
    title: {
      type: String,
      default: 'Confirm Data Source Change',
    },
    text: {
      type: String,
      default: 'There might be some data loss. Do you want to continue?',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    cancelTitle: {
      type: String,
      default: 'Cancel',
    },
    continueTitle: {
      type: String,
      default: 'Continue',
    },
    continueButtonColor: {
      type: String,
      default: 'primary',
    },
  },
  emits: ['cancelClicked', 'continueClicked'],
  setup(props, { emit }) {
    const showDialog = ref(false)
    function handleCancel() {
      emit('cancelClicked')
    }

    function handleContinue() {
      emit('continueClicked')
    }

    return { handleCancel, handleContinue, showDialog, props }
  },
})
</script>
